import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth.service';
import { ERROR_MSG, SUCCESS_MSG } from '../../shared/errorMessages';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  email: string;
  constructor(public dialogRef: MatDialogRef<ForgotPasswordComponent>,
    private _snackBar: MatSnackBar,
    private authServ: AuthService ) {
    this.email="";
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  resetPassword() {
    this.authServ.forgotPassword(this.email)
     .then((response) => {
        this._snackBar.open(response.data, null, {
          duration: 3000,
        });
      }).catch((error) => {
        this._snackBar.open(ERROR_MSG[error.code], null, {
          duration: 3000,
        });
      });
      this.dialogRef.close();
  }

}
